import { MenuItem as ReshapedMenuItem } from "reshaped";

import { type Action, getActionAnchorProps, getActionClickableProps } from "../../action/Action";
import { iconsComponents } from "../Icon/constants";
import type { IconName } from "../Icon/types";

type MenuItemProps = {
    label: string;
    icon?: IconName;
    action: Action;
    selected?: boolean;
};

export default function MenuItem(props: MenuItemProps) {
    const { label, icon, action, selected = false } = props;
    const hrefProps = getActionAnchorProps(action);
    const onClickProps = getActionClickableProps(action);
    return (
        <ReshapedMenuItem
            {...hrefProps}
            {...onClickProps}
            icon={icon ? iconsComponents[icon] : null}
            highlighted={selected}
        >
            {label}
        </ReshapedMenuItem>
    );
}
